export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./hdraces-bets.vue?vue&type=template&id=1fabb44b&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/players/player/hdraces-bets.vue?vue&type=template&id=1fabb44b&scoped=true
// module id = bV7T
// module chunks = 0